const { isProdEnv } = require('../../../../utils/ej-utils');
const { isCypress } = require('../../../../utils/testUtils');

const NPOS_NEW_UI_ENABLED_COUNTRIES = ['IND']; // India stores should use EJ New UI only

const NPOS_REPRINT_DISABLED_COUNTRIES = ['FRA', 'SWE']; // Receipt reprint is not allowed from NPOS EJ in these countries

const isNposNewUiEnabledByDefault = (countryCode) => NPOS_NEW_UI_ENABLED_COUNTRIES.includes(countryCode);

const isNposNewUiSwitchAvailable = (countryCode) => !isProdEnv() && !isNposNewUiEnabledByDefault(countryCode);

const isNposReprintEnabled = (countryCode) => !NPOS_REPRINT_DISABLED_COUNTRIES.includes(countryCode);

// used for cypress tests only
if (isCypress()) {
  // eslint-disable-next-line fp/no-mutating-methods
  NPOS_NEW_UI_ENABLED_COUNTRIES.push('NLD', 'USA');
}

module.exports = {
    isNposNewUiEnabledByDefault, isNposNewUiSwitchAvailable, isNposReprintEnabled
};
